import { render, staticRenderFns } from "./KanbanCreateDialog.vue?vue&type=template&id=4316c945&scoped=true&lang=pug&"
import script from "./KanbanCreateDialog.vue?vue&type=script&lang=ts&"
export * from "./KanbanCreateDialog.vue?vue&type=script&lang=ts&"
import style0 from "./KanbanCreateDialog.vue?vue&type=style&index=0&id=4316c945&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4316c945",
  null
  
)

export default component.exports